module.exports = __webpack_public_path__ + "img/default_avatar.ec086087.png";